<template>
  <div>
    <Breadcrumb :title="'Issuance'"></Breadcrumb>
    <IssuanceForm
      :ref="'IssuanceInfoForm'"
      :ProgramUnitClassJsonData="ProgramUnitClassJsonData"
      :partnerAutoCompleteDisplayedValue="partnerAutoCompleteDisplayedValue"
      :programAutoCompleteDisplayedValue="programAutoCompleteDisplayedValue"
      :IssuanceInfo="IssuanceJSON"
      :IssuanceModalLabel="modalConfig"
    ></IssuanceForm>
    <div>
      <BaseSearchBar :config="search" @keyupSearch="filterGrid"></BaseSearchBar>
    </div>
    <div class="btnDiv">
      <BaseToolBar :config="toolbarConfig" @buttonClicked="toolbarOnClick"></BaseToolBar>
    </div>
    <div>
      <BaseGrid
        :config="gridConfig"
        :excelExport="excelExport"
        :query="gridConfig.query"
        :colorizeColumn="true"
        :mode="'editform'"
        @EditItem="EditIssuance"
        @DeleteItem="DeleteItemfromGrid"
        @AttachItem="IssuanceAttachment"
      ></BaseGrid>
    </div>
    <IssuanceDocumentDropoffForm
      ref="issuanceDocument"
      :docModalConfig="docModalConfig"
      :filterCondition="filterCondition"
      :transactionRecord="selectedIssuance"
    ></IssuanceDocumentDropoffForm>
  </div>
</template>

<script>
import $ from "jquery";
import {
  GridConfig,
  ToolbarConfig,
  UnitClassUpdateConfig,
  IssuanceSubscriptionConfig
} from "./IssuanceEventConfig.js";
import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import BaseGrid from "@/components/base/BaseGrid.vue";
import apiUtil from "@/services/apiUtil.js";
import funcUtil from "@/services/funcUtil.js";
import BaseSearchBar from "@/components/base/BaseSearchBar.vue";
import BaseToolBar from "@/components/base/BaseToolbar.vue";
import toolbarUtility from "@/services/toolbarUtility.js";
import IssuanceForm from "@/components/forms/IssuanceForm.vue";
import BaseModelUnitClass from "@/models/BaseModelUnitClass.js";
import BaseModelProgram from "@/models/BaseModelProgram.js";
import BaseModelDocument from "@/models/BaseModelDocument.js";
import BaseModelUnitRunningTotal from "@/models/BaseModelUnitRunningTotal.js";
import BaseModelTransactionLog from "@/models/BaseModelTransactionLog.js";
import IssuanceDocumentDropoffForm from "@/components/forms/IssuanceDocumentDropoffForm.vue";
import { mapGetters, mapActions, mapState } from "vuex";
import _ from "lodash";
import { isNullOrUndefined } from "util";
import BusinessEventApprovalMixin from "@/mixins/BusinessEventApprovalMixin.js";

export default {
  name: "IssuanceEvent",
  mixins: [apiUtil, funcUtil, toolbarUtility, BusinessEventApprovalMixin],
  components: {
    Breadcrumb,
    BaseGrid,
    BaseSearchBar,
    BaseToolBar,
    IssuanceForm,
    IssuanceDocumentDropoffForm
  },
  data: function() {
    return {
      gridConfig: GridConfig,
      gridId: GridConfig.grid.gridId,
      grid: $("#" + GridConfig.grid.gridId).data("kendoGrid"),
      toolbarConfig: ToolbarConfig,
      search: {
        SearchData: ""
      },
      IssuanceMasterData: {},
      BaseModelUnitClass: BaseModelUnitClass,
      BaseModelProgram: BaseModelProgram,
      BaseModelUnitRunningTotal: BaseModelUnitRunningTotal,
      BaseModelDocument: BaseModelDocument,
      modalConfig: {
        modalName: "",
        modalAddorEdit: ""
      },
      // Document dropoff modal
      docModalConfig: {
        modalName: "Issuance Documents",
        modalIdandRef: "docModal",
        isFooter: false
      },
      // Filter condition for Document dropoff modal
      filterCondition: {
        filter: "",
        limit: 500
      },
      selectedIssuance: {},

      IssuanceJSON: [],
      // IssuanceAddJSON: {
      //Id: "",
      // BusinessEvent:"",
      // ProgramId:"",
      // ReceiverId:"",
      // ProgramTitle:"",
      // ReceiverFullName:"",
      // UnitClass:"",
      // UnitType:"",
      // UnitPool:"",
      // Unit:"",
      // TransactionDate:"",
      // },
      IssuanceEditJSON: {
        Id: null,
        BusinessEvent: "",
        ProgramId: null,
        ReceiverId: null,
        ProgramTitle: "",
        ReceiverFullName: "",
        UnitClass: "",
        UnitType: "",
        VestingType: "",
        UnitPool: "",
        Unit: 0,
        TransactionDate: ""
      },
      partnerAutoCompleteDisplayedValue: {
        displayedValue: ""
      },
      programAutoCompleteDisplayedValue: {
        displayedValue: ""
      },
      ProgramUnitClassJsonData: {
        option: []
      }
    };
  },
  mounted() {
    const self = this;
    //changes for Toolbar
    self._loadGridSettings(self.gridId);

    //bind databound event to grid
    // self.grid.bind("dataBound", self.UpdateIssuanceMasterData);
    let grid = $("#issuanceGrid").data("kendoGrid");
    grid.bind("dataBound", self.UpdateIssuanceMasterData);
    grid.dataSource.fetch();
  },
  computed: {
    ...mapGetters("getModule", ["withFilter"]),
    ...mapState("postModule", ["response"])
  },
  methods: {
    ...mapActions("postModule", [
      "DeleteItem",
      "UpdateAllItems",
      "CreateAllItems",
      "triggerWorkflow"
    ]),
    UpdateIssuanceMasterData: function(fromFilter, filterMasterData) {
      if (fromFilter == true) {
        this.IssuanceMasterData = filterMasterData;
      } else {
        this.IssuanceMasterData = JSON.parse(
          JSON.stringify(
            $("#issuanceGrid")
              .data()
              .kendoGrid.dataSource.data()
          )
        );
      }
      //Disable Rows which are not pending
      this._disableGridRow("issuanceGrid", "WorkflowStatus", "neq", "pending");
    },

    toolbarOnClick: function(e) {
      e.preventDefault();
      switch (e.id) {
        case "btnAddIssuance":
          this.AddIssuance();
          window.$("#BaseModal").modal("toggle");
          break;
        case "btnApproveIssuance":
          this.ApproveIssuance();
          break;
        case "btnBulkAttachment":
          this.AttachBatchDocuments();
          break;
        case "btnBulkImportIssuance":
          // this._AlertPopup("Bulk import screen is in progress...");
          this.$router.push("/event/issuance/upload");
          break;
        // case "btnRefresh":
        // 	this.refreshGrid();
        // 	break;
      }
      this._baseToolBarEvents("issuanceGrid", ...arguments);
    },

    async ApproveIssuance() {
      let grid = $("#issuanceGrid").data("kendoGrid");
      let selectedItem = [];
      let TransactionData = [];
      let triggerItemIds = [];
      let UnitClassSet = new Set();
      grid.select().each(function() {
        let selectedDataItem = JSON.parse(JSON.stringify(grid.dataItem(this)));
        if (selectedDataItem.WorkflowStatus == "Pending") {
          selectedDataItem.Status = "Processing";
          //push the dataItem into the array
          selectedItem.push(selectedDataItem);
        }
      });
      if (selectedItem.length > process.env.VUE_APP_ApprovalLimitCount) {
        this._AlertPopup(
          `You can only approve ${process.env.VUE_APP_ApprovalLimitCount} records at a time`,
          "info"
        );
        return;
      }
      selectedItem.forEach(Issuance => {
        let transaction = {};

        if (Issuance.VestingType.toLowerCase() === "custom") {
          triggerItemIds.push(Issuance.Id);
        }

        transaction.BusinessEvent = Issuance.BusinessEvent;
        transaction.ProgramId = Issuance.ProgramId;
        transaction.UnitClass = Issuance.UnitClass;
        transaction.UnitType = Issuance.UnitType;
        transaction.UnitPool = Issuance.UnitPool;
        transaction.Unit = Issuance.Unit;
        transaction.VestingType = Issuance.VestingType;
        transaction.TransactionDate = Issuance.TransactionDate;
        transaction.PartnerId = Issuance.ReceiverId;
        transaction.TransactionId = Issuance.Id;
        TransactionData.push(transaction);

        if (Issuance.UnitPool === "Treasury") {
          let TransactionTreasury = _.clone(transaction);
          TransactionTreasury.PartnerId = 1;
          TransactionData.push(TransactionTreasury);
        }
        //Find the Unit Class Record Corresponding to Program and UnitClass
        let unitClassFilter = {
          filter:
            "ProgramId eq " +
            Issuance.ProgramId +
            " and UnitClass eq " +
            "'" +
            Issuance.UnitClass +
            "'"
        };
        let unitClassResponse = this.withFilter(
          BaseModelUnitClass.list,
          unitClassFilter
        );
        if (unitClassResponse && unitClassResponse[0]) {
          let unitClassobj = unitClassResponse[0];
          unitClassobj.UnitIssued = "Yes";
          UnitClassSet.add(unitClassobj);
        }
      });
      let UnitClassData = [...UnitClassSet];
      //console.log(UnitClassData)
      if (selectedItem.length <= 0) {
        // alert("Please select atleast one item.");
        // this.$swal({ type: "info", text: "Please select atleast one item." });
        this._AlertPopup("Please select atleast one pending item.", "info");
      } else {
        const message =
          "Are you sure you want to approve the selected record(s)?";
        let result = await this._ConfirmationPopup(message, "APPROVE"); //.then(result => {
        if (result.value) {
          //need to update the DB
          //console.log(selectedItem);
          //using Update All method
          const approveConfig = {
            Issuance: {
              config: GridConfig,
              updateData: selectedItem,
              processInBatches: true
            }
          };
          let transactionCreateConfig = {
            TransactionLog: {
              config: BaseModelTransactionLog,
              createData: TransactionData,
              processInBatches: true
            }
          };
          let unitClassUpdateConfig = {
            UnitClass: {
              config: UnitClassUpdateConfig,
              updateData: UnitClassData,
              processInBatches: true
            }
          };

          //let loader = this.$loading.show();
          this._APICrudPopup("APICrudpopup");
          try {
            let transactionCreateResponse = null;
            let unitClassUpdateResponse = null;

            let approveResponse = await this.UpdateAllItems(approveConfig);
            console.log(`approveResponse:`,approveResponse);
            if (approveResponse) {
              transactionCreateResponse = await this.CreateAllItems(
                transactionCreateConfig
              );
            }
            console.log(`transactionCreateResponse:`,transactionCreateResponse);

            if (transactionCreateResponse) {
              unitClassUpdateResponse = await this.UpdateAllItems(
                unitClassUpdateConfig
              );
            }
            console.log('');
            console.log('-----------------------------------------------------------------------------------------');
            console.log(`unitClassUpdateResponse:`,unitClassUpdateResponse);
            console.log(`process.env.VUE_APP_BusinessEventApproval:`,process.env.VUE_APP_BusinessEventApproval);

            if (
              unitClassUpdateResponse &&
              process.env.VUE_APP_BusinessEventApproval == "true"
            ) {
              console.log(`Going to run _RunningTotalEvent()...`);
              let runningTotalResponse = await this._RunningTotalEvent(
                TransactionData,
                true,
                true,
                true
              );
              console.log("runningTotalResponse", runningTotalResponse);
            }

            if (triggerItemIds !== null && triggerItemIds.length > 0) {
              let workflow = {};
              workflow['itemIds'] = triggerItemIds;
              await this.triggerWorkflow(workflow);
            }

            $("#issuanceGrid")
              .data()
              .kendoGrid.dataSource.read();
            
            this._AlertPopup("Submitted for Processing Successfully!","success");
          } catch (error) {
            this._AlertPopup("Some Error Occurred!", "info");
          }
          //loader.hide();
        }
        //});
      }
    },
    
    filterGrid: function() {
      let self = this;

      var currentMasterdata = this.IssuanceMasterData;

      let filteredData = this._filterGrid(
        this.IssuanceMasterData,
        this.search.SearchData
      );

      $("#issuanceGrid")
        .data("kendoGrid")
        .dataSource.data(filteredData);
      this.UpdateIssuanceMasterData(true, currentMasterdata);
    },
    AddIssuance: function() {
      this.modalConfig.modalName = "Add Issuance";
      this.modalConfig.modalAddorEdit = "add";
      this.ProgramUnitClassJsonData.option = [];
      var IssuanceAddJSON = {
        Id: null,
        BusinessEvent: "",
        ProgramId: null,
        ReceiverId: null,
        ProgramTitle: "",
        ReceiverFullName: "",
        UnitClass: "",
        UnitType: "Standard",
        VestingType: "",
        UnitPool: "",
        Unit: 0,
        TransactionDate: null,
        Status: "",
        TreasuryUnits: 0,
        VestStartDate: null,
        VestYear1Date: null,
        VestYear2Date: null,
        VestYear3Date: null,
        VestYear4Date: null,
        VestCliffDate: null,

        Note: "",
        ProgramTitle: "",
        ProgramAlias: "",
        ProgramEIN: "",
        ProgramFormationDate: "",
        ProgramFinalCloseDate: "",
        ProgramMultiClass: "",
        ProgramIncomeSource: "",
        ProgramStateSource: "",
        PartnerFirstName: "",
        PartnerMiddleName: null,
        PartnerLastName: "",
        PartnerEntityName: null,
        ReceiverFullName: "",
        PartnerTaxId: "",
        PartnerTSDocId: "",
        PartnerDomestic: "",
        PartnerPartnerStatus: null,
        PartnerHireDate: "",
        PartnerLeaveDate: null,
        PartnerEMail: "",
        PartnerAddress1: "",
        PartnerAddress2: null,
        PartnerCity: "",
        PartnerState: "",
        PartnerPostalCode: null,
        PartnerCountry: "",
        PartnerMailAddress1: "",
        PartnerMailAddress2: null,
        PartnerMailCity: "",
        PartnerMailState: "",
        PartnerMailPostalCode: null,
        PartnerMailCountry: ""
      };
      this.partnerAutoCompleteDisplayedValue.displayedValue = "";
      this.programAutoCompleteDisplayedValue.displayedValue = "";
      this.$refs.IssuanceInfoForm.OutstandingTreasuryUnits = 0;
      this.IssuanceJSON = IssuanceAddJSON;
      // this.IssuanceAddJSONId = "";
      // this.$refs.ProgramInfo.$refs.refProgramForm.errors.clear();
    },
    EditIssuance: function(e) {
      let self = this;
      e.preventDefault();
      this.modalConfig.modalName = "Edit Issuance";
      this.modalConfig.modalAddorEdit = "edit";
      //alert("Edit button clicked from BaseGrid..");
      var gview = window.$("#issuanceGrid").data("kendoGrid");
      // var dataItem1 = gview.dataItem(window.$(e.currentTarget).closest("tr"));
      var dataItem = JSON.parse(
        JSON.stringify(gview.dataItem(window.$(e.currentTarget).closest("tr")))
      );
      //  alert(JSON.stringify(dataItem));
      this.IssuanceEditJSON = dataItem;
      // this.IssuanceJSON = this.IssuanceEditJSON;
      this.partnerAutoCompleteDisplayedValue.displayedValue = this.IssuanceEditJSON.ReceiverFullName;
      this.programAutoCompleteDisplayedValue.displayedValue = this.IssuanceEditJSON.ProgramTitle;
      this.ProgramUnitClassJsonData.option = [];

      let unitClassQuery = { filter: "Program/Id eq " + dataItem.ProgramId };

      this.ProgramUnitClassJsonData.option = this.withFilter(
        BaseModelUnitClass.list,
        unitClassQuery
      );
      this.IssuanceJSON = this.IssuanceEditJSON;
      //Calculating Outstanding Treasury Units
      this.$refs.IssuanceInfoForm.OutstandingTreasuryUnits = 0;
      this.$refs.IssuanceInfoForm.calculateOutstandingTreasuryUnits(
        this.IssuanceJSON
      );

      window.$("#BaseModal").modal("toggle");
    },
    DeleteItemfromGrid: function(e) {
      e.preventDefault();
      //alert("Delete button clicked from BaseGrid..");
      const message = "Are you sure you want to delete this record?";
      this._ConfirmationPopup(message, "DELETE").then(result => {
        if (result.value) {
          var gview = window.$("#issuanceGrid").data("kendoGrid");
          var dataItem = gview.dataItem(
            window.$(e.currentTarget).closest("tr")
          );

          var deleteData = {
            Id: dataItem.Id
          };

          let items = { list: GridConfig, payload: deleteData };
          //let loader = this.$loading.show();
          this._APICrudPopup("APICrudpopup");
          this.DeleteItem(items)
            .then(res => {
              //console.log(this.response);
              $("#issuanceGrid")
                .data()
                .kendoGrid.dataSource.read();
              //loader.hide();
              this._AlertPopup("Deleted successfully!", "success");
            })
            .catch(error => {
              this._AlertPopup("Some Error Occurred!", "info");
            })
            .finally(() => {
              //loader.hide();
            });
        }
      });
    },
    // Issuance Documnet Dropoff
    IssuanceAttachment: function(e) {
      let self = this;
      e.preventDefault();
      const gview = window.$("#issuanceGrid").data("kendoGrid");
      const dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));

      this.selectedIssuance = { ...dataItem };
      //TEMP: Only for Transfer Page.. Building Partner Record for the Time Being
      (this.selectedIssuance.PartnerTitle = dataItem.ReceiverFullName),
        (this.selectedIssuance.PartnerId = dataItem.ReceiverId);
      this.selectedIssuance.TransactionID = dataItem.Id;

      //let batchQueryString = this.getBatchGUIDQueryString(this.selectedIssuance.BatchGUID);

      this.filterCondition.batchQuery = true;

      let BatchGUIDArray = self.GetBatchGUIDArray(
        this.selectedIssuance.BatchGUID
      );

      this.filterCondition.filter = function(o) {
        return (
          o.BusinessEvent == "Issuance" &&
          (o.TransactionID == dataItem.Id ||
            BatchGUIDArray.includes(o.BatchGUID))
        );
      };

      //alert(this.filterCondition.filter)

      this.$refs.issuanceDocument.$refs.issuanceDocumentMgr.resetDropZoneGrid();
      window.$("#docModal").modal("toggle");
    },
    AttachBatchDocuments() {
      let selectedItem = [];
      let selectedRowCount = 0;

      //Get Next Batch Id
      const result = this.withFilter(BaseModelDocument.list, "");
      let batchId =
        result.length <= 0 ? 1 : this._getIncrementalID(result, "BatchGUID");

      console.log(`AttachBatchDocuments - batchId = [${batchId}]`);


      //Partner Program Concatenated List Change
      let programIdlist = new Set();
      let partnerIdList = new Set();

      let grid = $("#issuanceGrid").data("kendoGrid");
      grid.select().each(function() {
        selectedRowCount++;
        let selectedDataItem = JSON.parse(JSON.stringify(grid.dataItem(this)));
        let tempBatchId = [];
        if (
          !isNullOrUndefined(selectedDataItem.BatchGUID) &&
          !selectedDataItem.BatchGUID == ""
        ) {
          tempBatchId = selectedDataItem.BatchGUID.split(",");
        }
        tempBatchId.push(batchId);
        selectedDataItem.BatchGUID = tempBatchId.toString();
        selectedItem.push(selectedDataItem);
        programIdlist.add(selectedDataItem.ProgramId);
        partnerIdList.add(selectedDataItem.ReceiverId);
      });

      if (selectedRowCount <= 1) {
        this._AlertPopup("Please Select Atleast 2 Rows", "info");
      } else {
        const batchConfig = {
          Issuance: {
            config: GridConfig,
            updateData: selectedItem
          }
        };

        this.selectedIssuance = {};
        this.selectedIssuance.ProgramId = null;
        this.selectedIssuance.PartnerId = null;
        this.selectedIssuance.ProgramIdList = [...programIdlist].toString();
        this.selectedIssuance.PartnerIdList = [...partnerIdList].toString();
        this.selectedIssuance.TransactionID = null;
        this.selectedIssuance.BusinessEvent = "Issuance";
        this.selectedIssuance.Type = "batch";
        this.selectedIssuance.BatchGUID = batchId;
        this.selectedIssuance.batchConfig = batchConfig;
        this.selectedIssuance.parentGridId = "issuanceGrid";
        this.filterCondition.batchQuery = false;

        this.filterCondition.filter = `BusinessEvent eq 'Issuance' and BatchGUID eq ${batchId}`;

        this.$refs.issuanceDocument.$refs.issuanceDocumentMgr.resetDropZoneGrid();
        window.$("#docModal").modal("toggle");
      }
    }
  }
};
</script>
<style>
.float-right-btn {
  float: right !important;
  margin-right: 0.375em;
}
</style>

